<template>
    <div class="editBestellung container">
        <h3 v-if="bestellung.Firma.length > 1" class="page-header">Bestellung editieren <br />Knr.{{ bestellung.Kundennummer }} | {{ bestellung.Firma }} | {{ bestellung.Bezirk }}</h3>
        <h3 v-else class="page-header">Bestellung editieren <br />Knr.{{ bestellung.Kundennummer }} | {{ bestellung.Nachname }} | {{ bestellung.Bezirk }}</h3>
        <div class="jumbotron">
            <h4>Termindetails</h4>
            <div class="form-group">
                <label>Datum:</label>
                <input type="date" class="form-control" placeholder="Datum" v-model="bestellung.Datum" />
            </div>
            <div class="form-group">
                <label>Uhrzeit-Start:</label>
                <input type="time" class="form-control" placeholder="Uhrzeit" v-model="bestellung.Uhrzeit" />
                <label>Uhrzeit-Ende:</label>
                <input type="time" class="form-control" placeholder="Uhrzeit" v-model="bestellung.Enduhrzeit" />
            </div>
            <div class="form-group">
                <label>Fahrer:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label>

                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="FahrerCheck" id="FahrerCheck1" value="1" v-model="bestellung.fahrer" />
                    <label class="form-check-label" for="FahrerCheck1">Fahrer 1</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="FahrerCheck" id="FahrerCheck2" value="2" v-model="bestellung.fahrer" />
                    <label class="form-check-label" for="FahrerCheck2">Fahrer 2</label>
                </div>
            </div>
        </div>
        <div class="jumbotron">
            <div class="form-group">
                <label>Selbsteinkäufer:</label>

                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="SelbsteinkaeuferCheck" id="SelbsteinkaeuferCheck1" value="1" v-model="bestellung.Selbsteinkaeufer" />
                    <label class="form-check-label" for="SelbsteinkaeuferCheck1">Ja</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="SelbsteinkaeuferCheck" id="SelbsteinkaeuferCheck2" value="0" v-model="bestellung.Selbsteinkaeufer" />
                    <label class="form-check-label" for="SelbsteinkaeuferCheck2">Nein</label>
                </div>
            </div>
            <div class="form-group">
                <label>Taschen:</label>

                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="Taschen" id="Taschen1" value="1" v-model="bestellung.Taschen" />
                    <label class="form-check-label" for="Taschen1">Ja</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="Taschen" id="Taschen2" value="0" v-model="bestellung.Taschen" />
                    <label class="form-check-label" for="Taschen2">Nein</label>
                </div>
            </div>
            <div v-if="bestellung.Taschen == 1" class="form-group">
                <label>Anzahl:</label>
                <input type="number" class="form-control" placeholder="Anzahl" v-model="bestellung.Taschen_anzahl" />
            </div>
            <div class="form-group">
                <label>Kisten:</label>

                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="Kisten" id="Kisten1" value="1" v-model="bestellung.Kisten" />
                    <label class="form-check-label" for="Kisten1">Ja</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="Kisten" id="Kisten2" value="0" v-model="bestellung.Kisten" />
                    <label class="form-check-label" for="Kisten2">Nein</label>
                </div>
            </div>
            <div v-if="bestellung.Kisten == 1" class="form-group">
                <label>Anzahl:</label>
                <input type="number" class="form-control" placeholder="Anzahl" v-model="bestellung.Kisten_anzahl" />
            </div>
        </div>
        <div class="jumbotron">
            <div class="form-group">
                <label>Shop:</label>

                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="Shop" id="Shop1" value="1" v-model="bestellung.Shop" />
                    <label class="form-check-label" for="Shop1">Ja</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="Shop" id="Shop2" value="0" v-model="bestellung.Shop" />
                    <label class="form-check-label" for="Shop2">Nein</label>
                </div>
            </div>
            <div v-if="bestellung.Shop == 1" class="form-group">
                <label>Bemerkung:</label>
                <input type="text" class="form-control" placeholder="Bemerkung" v-model="bestellung.Shop_Bemerkung" />
            </div>
            <div class="form-group">
                <label>Bäcker:</label>

                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="Baecker" id="Baecker1" value="1" v-model="bestellung.Baecker" />
                    <label class="form-check-label" for="Baecker1">Ja</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="Baecker" id="Baecker2" value="0" v-model="bestellung.Baecker" />
                    <label class="form-check-label" for="Baecker2">Nein</label>
                </div>
            </div>
            <div v-if="bestellung.Baecker == 1" class="form-group">
                <label>Bemerkung:</label>
                <input type="text" class="form-control" placeholder="Bemerkung" v-model="bestellung.Baecker_Bemerkung" />
            </div>
            <div class="form-group">
                <label>Tiefkühl-Waren:</label>

                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="TK" id="TK1" value="1" v-model="bestellung.TK" />
                    <label class="form-check-label" for="TK1">Ja</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="TK" id="TK2" value="0" v-model="bestellung.TK" />
                    <label class="form-check-label" for="TK2">Nein</label>
                </div>
            </div>
            <div v-if="bestellung.TK == 1" class="form-group">
                <label>Bemerkung:</label>
                <input type="text" class="form-control" placeholder="Bemerkung" v-model="bestellung.TK_Anmerkung" />
            </div>
            <div class="form-group">
                <label>Blumen:</label>

                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="Blumen" id="Blumen1" value="1" v-model="bestellung.Blumen" />
                    <label class="form-check-label" for="Blumen1">Ja</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="Blumen" id="Blumen2" value="0" v-model="bestellung.Blumen" />
                    <label class="form-check-label" for="Blumen2">Nein</label>
                </div>
            </div>
            <div v-if="bestellung.Blumen == 1" class="form-group">
                <label>Bemerkung:</label>
                <input type="text" class="form-control" placeholder="Bemerkung" v-model="bestellung.Blumen_Bemerkung" />
            </div>
        </div>
        <div class="jumbotron">
            <div class="form-group">
                <label>Bemerkung:</label>
                <input type="text" class="form-control" placeholder="Bemerkung zur Bestellung" v-model="bestellung.Bestellbemerkung" />
            </div>
        </div>
        <div class="jumbotron">
            <h4>Rechnungsdetails</h4>
            <div class="form-group">
                <label>Rechnung erstellen?:</label>

                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="Rechnung" id="Rechnung1" value="1" v-model="dbRechnung" />
                    <label class="form-check-label" for="Rechnung1">Ja</label>
                </div>
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="Rechnung" id="Rechnung2" value="0" v-model="dbRechnung" />
                    <label class="form-check-label" for="Rechnung2">Nein</label>
                </div>
            </div>
            <div v-if="dbRechnung == 1">
                <div>
                    Zuletzt erstellte Lieferübersicht:
                    <br />
                    {{ latestInvoice }}
                    <br />
                </div>
                <div class="form-group">
                    <v-text-field label="Einkaufswert" type="number" step="0.01" prefix="€" v-model="rechnung.wert"></v-text-field>
                </div>

                <v-select v-model="selectedPauschale" :items="pauschalen" item-text="text" item-value="value" label="Pauschale" return-object attach> </v-select>
                <div v-if="selectedPauschale.value == 'x'" class="form-group">
                    <label>Pauschale:</label>
                    <input type="number" step="0.01" class="form-control" placeholder="XX,XX" v-model="selectedPauschale.xPauschale" />
                </div>

                <v-select v-model="rechnung.typ" :items="typen" label="Typ" attach> </v-select>
                <v-select v-model="rechnung.schicht" :items="schichten" label="Typ" attach> </v-select>
            </div>
        </div>
        <div class="alert alert-danger" v-if="showErrorMessage">
            <button type="button" aria-hidden="true" class="close" v-on:click="disableNotification">×</button>
            <span>
                <b>Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut</b>
            </span>
        </div>

        <button v-on:click="createTermin" :disabled="btnDisabled" class="btn btn-primary">Speichern</button>
    </div>
</template>

<script>
    const moment = require("moment")
    export default {
        name: "editBestellung",
        data() {
            return {
                auth: "Basic " + window.btoa(process.env.VUE_APP_NODE_AUTH),
                latestInvoice: "",
                btnDisabled: false,
                rechnung: {
                    kundenNr: "",
                    wert: 0,
                    pauschale: 0,
                    datum: "",
                    typ: "Bar",
                    schicht: "Früh"
                },
                pauschalen: [
                    { text: "€ 0", value: 0 }
                    // {text: "€ 3", value: 3},
                    // {text: "€ 7", value: 7},
                    // {text: "€ X", value: "x" , xPauschale: 0},
                ],
                selectedPauschale: { text: "0 €", value: 0 },
                typen: ["Kredit", "Bar", "EC", "Retoure EC", "Retoure Bar", "Retoure Kredit"],
                schichten: ["Früh", "Spät"],
                xValue: 0,
                dbRechnung: 0,
                bestellung: {},
                alarm: "",
                termin: {},
                zeitende: "",
                showErrorMessage: false,
                dst: [
                    { year: 2019, start: "2019-03-31", ende: "2019-10-27" },
                    { year: 2020, start: "2020-03-29", ende: "2020-10-25" },
                    { year: 2021, start: "2021-03-28", ende: "2021-10-31" },
                    { year: 2022, start: "2022-03-27", ende: "2022-10-30" },
                    { year: 2023, start: "2023-03-26", ende: "2023-10-29" },
                    { year: 2024, start: "2024-03-31", ende: "2024-10-27" },
                    { year: 2025, start: "2025-03-30", ende: "2025-10-26" },
                    { year: 2026, start: "2026-03-29", ende: "2026-10-25" },
                    { year: 2027, start: "2027-03-28", ende: "2027-10-31" },
                    { year: 2028, start: "2028-03-26", ende: "2028-10-29" },
                    { year: 2029, start: "2029-03-25", ende: "2029-10-28" }
                ]
            }
        },
        methods: {
            createRechnung() {
                this.rechnung.datum = this.createDate()
                this.rechnung.kundenNr = this.bestellung.Kundennummer
                if (this.selectedPauschale.xPauschale > 0) {
                    this.rechnung.pauschale = this.selectedPauschale.xPauschale
                } else {
                    this.rechnung.pauschale = this.selectedPauschale.value
                }
                if (this.rechnung.typ == "Retoure Bar" || this.rechnung.typ == "Retoure Kredit" || this.rechnung.typ == "Retoure EC") {
                    this.rechnung.pauschale = 0
                }
                if (this.rechnung.wert == undefined || this.rechnung.wert == null || this.rechnung.wert == "") {
                    this.rechnung.wert = 0
                }
                console.log(this.rechnung)
                console.log(this.selectedPauschale)
                this.addRechnung(this.rechnung)
            },
            addRechnung(rechnung) {
                this.$http.post(process.env.VUE_APP_NODE_API_URL + "/heimspiel/rechnung/add", rechnung, { headers: { Authorization: this.auth } }).then(function (response) {
                    console.log(response)
                })
            },
            createDate() {
                var date = new Date(this.bestellung.Datum)
                var dd = String(date.getDate()).padStart(2, "0")
                var mm = String(date.getMonth() + 1).padStart(2, "0") //January is 0!
                var yyyy = date.getFullYear()

                var newDate = dd + "." + mm + "." + yyyy
                return newDate
            },
            disableNotification() {
                this.showErrorMessage = false
            },
            createTermin() {
                if (this.bestellung.Uhrzeit <= this.bestellung.Enduhrzeit && this.bestellung.Uhrzeit && this.bestellung.Enduhrzeit && this.bestellung.Datum) {
                    this.btnDisabled = true
                    var thisYear = moment.utc(this.bestellung.Datum, "YYYY-MM-DD").format("YYYY")
                    var terminDate = new Date(this.bestellung.Datum)

                    var dstEnd
                    var dstStart
                    for (var i = 0; i < this.dst.length; i++) {
                        if (this.dst[i].year == thisYear) {
                            dstEnd = new Date(this.dst[i].ende)
                            dstStart = new Date(this.dst[i].start)
                        }
                    }

                    moment.locale("de")
                    if (terminDate < dstEnd && terminDate >= dstStart) {
                        this.termin.start = this.bestellung.Datum + "T" + this.bestellung.Uhrzeit + ":00+02:00"

                        this.termin.ende = this.bestellung.Datum + "T" + this.bestellung.Enduhrzeit + ":00+02:00"
                    } else {
                        this.termin.start = this.bestellung.Datum + "T" + this.bestellung.Uhrzeit + ":00+01:00"
                        // var endzeit = moment(this.bestellung.Uhrzeit, "LT").add(30 ,"minutes").format("LT");

                        this.termin.ende = this.bestellung.Datum + "T" + this.bestellung.Enduhrzeit + ":00+01:00"
                    }
                    this.termin.adresse = this.bestellung.Strasse + " " + this.bestellung.Hausnummer + "," + this.bestellung.PLZ + " " + this.bestellung.Stadt
                    this.termin.bezeichnung = this.termin.bezeichnung + " | " + this.bestellung.Bezirk + " | Knr:" + this.bestellung.Kundennummer
                    if (this.bestellung.Firma.length < 2) {
                        if (this.bestellung.Selbsteinkaeufer == 0) {
                            this.termin.type = 0
                        } else {
                            this.termin.type = 1
                        }
                    } else {
                        this.termin.type = 2
                    }
                    // Wenn =! Fahrer 1 setze die entsprechende Fahrernummer vor die Bezeichnung
                    if (this.bestellung.fahrer == 1) {
                    } else {
                        this.termin.bezeichnung = "F" + this.bestellung.fahrer + "|" + this.termin.bezeichnung
                    }

                    // if (this.bestellung.Selbsteinkaeufer === 1) {
                    //     this.termin.farbe = 8;
                    // }
                    // else {
                    //     this.termin.farbe = 6;
                    // }

                    this.editBestellung(0, "no")
                    if (this.dbRechnung == 1) {
                        this.createRechnung()
                    }
                } else {
                    alert("Bitte korrecktes Datum, Start- und End-Uhrzeit angeben!")
                }
            },
            deleteTermin() {
                this.$http
                    .post(process.env.VUE_APP_NODE_API_URL + "/heimspiel/delete/termin", { id: this.bestellung.id, type: this.bestellung.kalender }, { headers: { Authorization: this.auth } })
                    .then(function (response) {
                        console.log(response)
                        if (response.body.error) {
                            console.log("error")
                            this.showErrorMessage = true
                        } else {
                            this.addTermin()
                        }
                    })
            },
            addTermin() {
                this.$http.post(process.env.VUE_APP_NODE_API_URL + "/heimspiel/add/termin", this.termin, { headers: { Authorization: this.auth } }).then((response) => {
                    console.log(response)
                    this.editBestellung(response.body.data.id, response.body.data.organizer.email)
                    if (this.dbRechnung == 1) {
                        this.createRechnung()
                    }
                })
            },
            editBestellung(id, kalender) {
                let updatedBestellung = {
                    Kundennummer: this.bestellung.Kundennummer,
                    Datum: this.bestellung.Datum,
                    Uhrzeit: this.bestellung.Uhrzeit,
                    Enduhrzeit: this.bestellung.Enduhrzeit,
                    Selbsteinkaeufer: this.bestellung.Selbsteinkaeufer,
                    Taschen: this.bestellung.Taschen,
                    Taschen_anzahl: this.bestellung.Taschen_anzahl,
                    Kisten: this.bestellung.Kisten,
                    Kisten_anzahl: this.bestellung.Kisten_anzahl,
                    Bestellbemerkung: this.bestellung.Bestellbemerkung,
                    Shop: this.bestellung.Shop,
                    Shop_Bemerkung: this.bestellung.Shop_Bemerkung,
                    Baecker: this.bestellung.Baecker,
                    Baecker_Bemerkung: this.bestellung.Baecker_Bemerkung,
                    TK: this.bestellung.TK,
                    TK_Anmerkung: this.bestellung.TK_Anmerkung,
                    Blumen: this.bestellung.Blumen,
                    Blumen_Bemerkung: this.bestellung.Blumen_Bemerkung,
                    terminId: id,
                    kalender: kalender,
                    fahrer: this.bestellung.fahrer,
                    auth: process.env.VUE_APP_PHP_AUTH
                }
                this.$http
                    .post(process.env.VUE_APP_NODE_API_URL + "/heimspiel/bestellung/update/" + this.$route.params.bestellnr, updatedBestellung, { headers: { Authorization: this.auth } })
                    .then(function (response) {
                        console.log(response)
                        this.$router.push({
                            path: "/tagestour",
                            query: { alarm: "Bestellung editiert!", date: this.bestellung.Datum }
                        })
                    })
            },
            latestInvoiceCheck(knr) {
                let customerData = {
                    kundenNr: knr
                }
                this.$http.post(process.env.VUE_APP_NODE_API_URL + "/heimspiel/rechnung/last", customerData, { headers: { Authorization: this.auth } }).then(function (response) {
                    console.log(response)
                    if (response.body.success == true) {
                        this.latestInvoice =
                            "Datum: " +
                            response.body.data[0].Lieferdatum +
                            " Wert: " +
                            response.body.data[0].Einkaufswert +
                            "€ Pauschale: " +
                            response.body.data[0].Pauschale +
                            "€ Typ: " +
                            response.body.data[0].Typ
                    }
                    if (response.body.success == false) {
                        this.latestInvoice = "Für diesen Kunden wurden noch keine Lieferscheine erzeugt."
                    }
                    if (response.body.error) {
                        this.latestInvoice = "Ein Fehler ist aufgetreten. Bitte kontaktieren Sie den Support."
                    }
                })
            },
            //sets type for printing invoice if customer is a company
            setType(firma, typ) {
                if (firma.length > 2 || typ == "Kredit") {
                    this.rechnung.typ = this.typen[0]
                }
            },
            fetchTermin(id) {
                this.$http.post(process.env.VUE_APP_PHP_API_URL + "/bestellung/" + id, { auth: process.env.VUE_APP_PHP_AUTH }).then(function (response) {
                    this.bestellung = response.body
                    moment.locale("de")
                    var formattedStarttime = moment(this.bestellung.Uhrzeit, "LTS").format("LT")
                    var formattedEndtime = moment(this.bestellung.Enduhrzeit, "LTS").format("LT")

                    this.bestellung.Uhrzeit = ""
                    this.bestellung.Uhrzeit = formattedStarttime
                    this.bestellung.Enduhrzeit = ""
                    this.bestellung.Enduhrzeit = formattedEndtime
                    // this.bestellung.beforeEdit = this.bestellung.Selbsteinkaeufer;
                    if (this.bestellung.Firma.length < 2) {
                        if (this.bestellung.Vorname && this.bestellung.Nachname) {
                            this.termin.bezeichnung = this.bestellung.Vorname + " " + this.bestellung.Nachname
                        } else {
                            this.termin.bezeichnung = this.bestellung.Nachname
                        }
                    } else {
                        this.termin.bezeichnung = this.bestellung.Firma
                    }
                    this.latestInvoiceCheck(response.body.Kundennummer)
                    this.setType(response.body.Firma, response.body.Typ)
                })
            }
        },
        created: function () {
            this.fetchTermin(this.$route.params.bestellnr)
        },
        components: {}
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
